var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-fertilizers"},[_c('search-bar',{attrs:{"type":"text","placeholder":_vm.$ml.get("Search"),"value":_vm.value},on:{"input":_vm.updateSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }